import { trpc } from "@mnk/frontend/lib/trpc";
import { roleToStr } from "@mnk/frontend/utils/roleToStr";
import type { GetUser } from "@mnk/shared/models/user";
import { useState } from "react";
import { Link } from "react-router-dom";
import { DeleteUserModal } from "./DeleteUserModal";

export const UsersList = () => {
  const [deleteUserModal, setDeleteUserModal] = useState<GetUser | null>(null);

  const getUser = trpc.getUser.useQuery();
  const me = getUser.data;
  const getUsers = trpc.getUsers.useQuery();
  const users = getUsers.data;

  return (
    <div className="w-full bg-white rounded-lg">
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        <p className="text-xl font-bold">ユーザー一覧</p>
        <Link to="/settings/users/new" className="text-sm text-white bg-blue-500 px-4 py-2 rounded-md">
          新規作成
        </Link>
      </div>
      <div className="p-4">
        <table className="w-full">
          <thead>
            <tr className="px-4 py-2">
              <th className="text-left px-4 py-2 bg-gray-100 border border-gray-200">メールアドレス</th>
              <th className="text-left px-4 py-2 bg-gray-100 border border-gray-200">名前</th>
              <th className="text-left px-4 py-2 bg-gray-100 border border-gray-200">ロール</th>
              <th className="text-left px-4 py-2 bg-gray-100 border border-gray-200">事業所名</th>
              <th className="text-left px-4 py-2 bg-gray-100 border border-gray-200">-</th>
            </tr>
          </thead>
          <tbody>
            {users?.map((user) => (
              <tr key={user.id}>
                <td className="p-4 border border-gray-200">{user.email}</td>
                <td className="p-4 border border-gray-200">{user.name}</td>
                <td className="p-4 border border-gray-200">{roleToStr(user.role)}</td>
                <td className="p-4 border border-gray-200">{user.officeName}</td>
                <td className="p-4 border border-gray-200">
                  <div className="flex gap-2">
                    <Link to={`/settings/users/${user.id}/edit`} className="text-sm text-blue-500 cursor-pointer">
                      編集
                    </Link>
                    {me?.id !== user.id ? (
                      <button
                        type="button"
                        onClick={() => setDeleteUserModal(user)}
                        className="text-sm text-red-500 cursor-pointer"
                      >
                        削除
                      </button>
                    ) : (
                      <p className="text-sm text-gray-500">-</p>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {deleteUserModal && (
        <DeleteUserModal
          user={deleteUserModal}
          onClose={() => setDeleteUserModal(null)}
          afterDeleteUser={getUsers.refetch}
        />
      )}
    </div>
  );
};
